export default __webpack_public_path__ + "static/khariSpeechAttack-a66d7f06ec6291a1c4b837662d28053d.svg";